/**
 * Environment Configuration
 * Centralized access to environment variables with type safety and validation
 */

interface EnvironmentConfig {
  env: string;
  isProd: boolean;
  apiBaseUrl: string;
  contentBaseUrl: string;
  contentApiV1Url: string;
  contentApiUrl: string;
  apiTimeout: number;
  debugMode: boolean;
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  const env = process.env.REACT_APP_ENV || "development";
  return {
    env,
    isProd: env === "production",
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "https://61fp1hi2c7.execute-api.us-east-1.amazonaws.com/dev/api/v1",
    contentBaseUrl: process.env.REACT_APP_CONTENT_BASE_URL || "https://content-delivery.dev.yetimyfriend.com",
    contentApiV1Url: process.env.REACT_APP_CONTENT_API_V1_URL || "https://content-delivery.dev.yetimyfriend.com/api/v1",
    contentApiUrl: process.env.REACT_APP_CONTENT_API_URL || "https://content-delivery.dev.yetimyfriend.com/api",
    apiTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT || "20000", 10),
    debugMode: process.env.REACT_APP_DEBUG_MODE === "true",
  };
};

const config = getEnvironmentConfig();

// Log environment info in development mode
if (config.debugMode) {
  console.log("🔧 Environment Configuration Loaded:", {
    env: config.env,
    apiBaseUrl: config.apiBaseUrl,
    contentApiV1Url: config.contentApiV1Url,
    apiTimeout: config.apiTimeout,
  });
}

export default config;
